'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'beer-mug-empty';
var width = 512;
var height = 512;
var aliases = ["beer"];
var unicode = 'f0fc';
var svgPathData = 'M32 32l352 0 0 64 96 0 32 0 0 32 0 176 0 20.8-19 8.4L384 381.7l0 98.3L32 480 32 32zM384 311.6l64-28.4L448 160l-64 0 0 151.6zM160 144l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224zm64 0l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224zm64 0l0-16-32 0 0 16 0 224 0 16 32 0 0-16 0-224z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBeerMugEmpty = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;